import React from 'react';
import { FaPlay, FaStar } from 'react-icons/fa';

function SearchResult({ item, openTrailerOverlay }) {
  const renderStreamingProviders = () => {
    if (item.streamingProviders && item.streamingProviders.length > 0) {
      return (
        <div className="streaming-logos-wrap" title="Available to stream on:">
          {item.streamingProviders.slice(0, 3).map((provider) => (
            <img
              key={provider.provider_id}
              src={`https://image.tmdb.org/t/p/original${provider.logo_path}`}
              alt={provider.provider_name}
              title={provider.provider_name}
              className="provider-logo-img"
              loading="lazy"
            />
          ))}
          {item.streamingProviders.length > 3 && (
            <span className="provider-overflow-badge" title="More providers available">
              +{item.streamingProviders.length - 3}
            </span>
          )}
        </div>
      );
    }
    return <span className="not-streaming-text">Not Streaming (NL)</span>;
  };

  const formattedRating = item.vote_average ? Number(item.vote_average).toFixed(1) : 'N/A';
  const isHighRating = item.vote_average && item.vote_average >= 7.0;
  
  const releaseDate = item.release_date || item.first_air_date;
  const releaseYear = releaseDate ? releaseDate.slice(0, 4) : '';
  const mediaType = item.media_type || item.mediaType || 'movie';
  const hasTrailer = Boolean(item.trailer);

  const posterSrc = item.poster_path
    ? `https://image.tmdb.org/t/p/w500${item.poster_path}`
    : 'https://via.placeholder.com/500x750/161224/8a2be2?text=Lumiflix';

  const title = item.title || item.name || 'Untitled';

  return (
    <div className="media-card" key={item.id}>
      <div className="card-poster-wrap">
        <img
          src={posterSrc}
          alt={title}
          className="card-poster-img"
          loading="lazy"
        />

        <div className="card-top-badges">
          <span className="badge-type">{mediaType === 'tv' ? 'TV Show' : 'Movie'}</span>
          {releaseYear && <span className="badge-year">{releaseYear}</span>}
        </div>

        {item.overview && (
          <div className="card-quick-overlay">
            <p className="quick-overview-text">{item.overview}</p>
          </div>
        )}
      </div>

      <div className="card-content-area">
        <a
          href={item.imdbURL || item.tmdbURL || '#'}
          target="_blank"
          rel="noopener noreferrer"
          className="card-title-link"
          title={title}
        >
          {title}
        </a>

        <div className="card-meta-row">
          <span className={isHighRating ? 'rating-pill-green' : 'rating-pill-neutral'}>
            <FaStar style={{ fontSize: '11px' }} />
            {formattedRating}
          </span>
          <div className="streaming-info-box">
            {renderStreamingProviders()}
          </div>
        </div>

        {hasTrailer ? (
          <button
            className="btn-card-trailer"
            onClick={() => openTrailerOverlay(item)}
            aria-label={`Watch trailer for ${title}`}
          >
            <FaPlay style={{ fontSize: '11px' }} />
            Watch Trailer
          </button>
        ) : (
          <button
            className="btn-card-trailer"
            disabled
            title="No trailer video available for this title"
          >
            No Trailer
          </button>
        )}
      </div>
    </div>
  );
}

export default SearchResult;